export default __webpack_public_path__ + "static/media/phone.39feb39d.svg";